<script setup lang="ts">
  import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
  } from "@/components/ui/card"
  import { Skeleton } from "@/components/ui/skeleton"
</script>

<template>
  <Card data-testid="balance-card-skeleton">
    <CardHeader>
      <CardTitle>Your Balance</CardTitle>
    </CardHeader>
    <CardContent>
      <Skeleton class="h-[32px] w-[250px] sm:h-[36px]" />
    </CardContent>
    <CardFooter>
      <Skeleton class="h-[36px] w-full sm:w-[151px]" variant="rounded" />
    </CardFooter>
  </Card>
</template>
